
export default {
    name: 'CouponItem',
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            showDescDialog: false
        }
    },
    computed: {
        couponsIntroduceList () {
            const parts = this.item.couponsIntroduce?.split('\n') || [] // 根据 \n 分割
            if (parts.length > 2) {
                parts[1] = parts.slice(1).join('\n') // 将多余的内容合并到第二项
                return parts.slice(0, 2) // 保留前两项
            }
            return parts
        }
    },
    methods: {
        /**
         * 说明弹窗并阻止下拉刷新
         */
        onShowDescDialog (showDescDialog) {
            this.showDescDialog = showDescDialog
        },
        handleClick () {
            this.$emit('click')
        }
    }
}
